module.exports = "#ifdef USE_TRIPLANAR\n\tOPosition = transformed;\n\tONormal = objectNormal;\n#endif\n";